import { createStore, compose, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import analytics from 'services/middle-ware/analytics'
import rootReducer from './root-reducer'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose // eslint-disable-line
export default initialState => createStore(
  rootReducer,
  initialState,
  composeEnhancers(applyMiddleware(thunk, analytics)),
)



// WEBPACK FOOTER //
// ./stores/configureStore.js